import { useState, useEffect } from 'react';
import { get } from '../../lib/crossover';

const CACHE = [];
const toUrl = (leagueId, seasonId, teamId) =>
  `/team/${teamId}/games?ordering=-start_time&limit=1&league_id=${leagueId}&season_id=${seasonId}&locked=true`;

export default function useLastGame(leagueId, seasonId, teamId) {
  const url = toUrl(leagueId, seasonId, teamId);
  const [lastGame, setLastGame] = useState(CACHE[url]);

  useEffect(() => {
    if (CACHE[url]) {
      setLastGame(CACHE[url]);
    } else {
      get(url).then(response => {
        CACHE[url] = {
          teamId,
          ...response.results[0],
          gameCount: response.count,
        };
        setLastGame(CACHE[url]);
      });
    }
  }, [url, teamId]);
  return lastGame;
}
